const info = [
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-595',
            connection_id: 'connection-529'
        },
        chain_2: {
            chain_name: 'persistencetestnet2',
            client_id: '07-tendermint-3',
            connection_id: 'connection-2'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-1037',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-7',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-19',
            connection_id: 'connection-14'
        },
        chain_2: {
            chain_name: 'quicksilvertestnet',
            client_id: '07-tendermint-6',
            connection_id: 'connection-4'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-13',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-20',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-1448',
            connection_id: 'connection-1552'
        },
        chain_2: {
            chain_name: 'sagatestnet',
            client_id: '07-tendermint-26',
            connection_id: 'connection-21'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-4946',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-20',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-965',
            connection_id: 'connection-865'
        },
        chain_2: {
            chain_name: 'sgetestnet',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-1568',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-1274',
            connection_id: 'connection-1175'
        },
        chain_2: {
            chain_name: 'stargazetestnet',
            client_id: '07-tendermint-621',
            connection_id: 'connection-633'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-4175',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-638',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-2436',
            connection_id: 'connection-2267'
        },
        chain_2: {
            chain_name: 'titantestnet',
            client_id: '07-tendermint-2',
            connection_id: 'connection-2'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-5969',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-2',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    },
    {
        $schema: '../../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosistestnet',
            client_id: '07-tendermint-1474',
            connection_id: 'connection-1380'
        },
        chain_2: {
            chain_name: 'xiontestnet',
            client_id: '07-tendermint-22',
            connection_id: 'connection-12'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-4410',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live'
                }
            }
        ]
    }
];
export default info;
